(function($) {
  
  var dataForm = $('#size-assist-form');
  
  function validateMeasurements() {
    const fields = ['bust', 'waist', 'hips'];
    
    /*
      for (const field of fields) {
      const value = $(`#${field}`).val().trim();
      if (value === '') {
        return false;
      }
      // if (!/^\d+$/.test(value) || parseInt(value) <= 0) {
        return false;
      }
    }
    return true;
  */

    for (const field of fields) {
      const value = $(`#${field}`).val().trim();
    
      // Check if input is empty
      if (value === '') {
        return false;
      }
    
      // Validate that the value is a positive number (whole or decimal)
      if (!/^[+]?(?:\d*\.\d+|\d+)$/.test(value)) {
        return false;
      }
    
      // Convert to number and check if > 0
      const num = parseFloat(value);
      if (num <= 0) {
        return false;
      }
    }

    return true;
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var measurementsData = null;
  if (getCookie('best_match_result_data')) {
    measurementsData = JSON.parse(getCookie('best_match_result_data'));
  }

  if(measurementsData) {
		$('input[name="chest_bust"]').val(measurementsData.chest_bust);
		$('input[name="waist"]').val(measurementsData.waist);
		$('input[name="hips"]').val(measurementsData.hips);
		$("#" + measurementsData.gender).prop("checked", true);
		$("#" + measurementsData.measurement_unit).prop("checked", true);
		$("#" + measurementsData.height).prop("checked", true);

    var postData = {
      gender: measurementsData.gender,
      chest_bust: measurementsData.chest_bust.trim(),
      waist: measurementsData.waist.trim(),
      hips: measurementsData.hips.trim(),
      measurement_unit: measurementsData.measurement_unit,
      height: measurementsData.height
    };
    $('#size-finder-loader').show();
    $('#size-assist-form').hide();
    setTimeout(function() {
      fetch('https://theshopcompany.vercel.app/api/calculate-size-test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData)
      })
      .then(response => response.json())
      .then(data => {
        if (postData.gender === 'femaleall') {
          updateUIWithResultsFemaleAll(data, postData);
        } else {
          updateUIWithResults(data, postData);
        }

      }).catch(error => {
        console.error('Error fetching size:', error);
        $(".size-error-message").show()
        $(".size-error-message").text("Error calculating size. Please try again.");
        $('#size-finder-loader').hide();
        $('#size-assist-form').fadeIn();
      });
    }, 350);
  }
    const menuItem = $('.size-finder-menu-item');  
  
  $(document).on('click', '.size-assist-form', function(event) {
    event.preventDefault();
    // need to stop the window from closing upon submission of the form
    event.stopPropagation();
    menuItem.addClass('locked-open');
    //remember state after reload
    sessionStorage.setItem('sizeFinderLocked', '1');

    if (!validateMeasurements()) {
      $(".size-error-message").show()
      $(".size-error-message").text("Please fill all measurement fields.");
      return false;
    } else {
      $(".size-error-message").hide()
      $(".size-error-message").text("");
    }

    $('#size-finder-loader').show();
    $('#size-assist-form').fadeOut();

    var postData = {
      gender: $('input[name="gender"]:checked').val(),
      chest_bust: $('#bust').val().trim(),
      waist: $('#waist').val().trim(),
      hips: $('#hips').val().trim(),
      measurement_unit: $('input[name="measurement_unit"]:checked').val(),
      height: $('input[name="height"]:checked').val()
    };
    const isValidData = ['chest_bust', 'waist', 'hips'].every(key => 
      //postData[key] !== '' && /^\d+$/.test(postData[key]) && parseInt(postData[key]) > 0
      postData[key] !== '' && /^[+]?(?:\d*\.\d+|\d+)$/.test(postData[key]) && parseInt(postData[key]) > 0
    );
    
    if (!isValidData) {
      $(".size-error-message").show()
      $(".size-error-message").text("Invalid input detected. All fields must contain positive whole numbers.");
      $('#size-finder-loader').hide();
      $('#size-assist-form').fadeIn();
      return false;
    } else {
      $(".size-error-message").hide()
      $(".size-error-message").text("");
    }

    setTimeout(function() {
      fetch('https://theshopcompany.vercel.app/api/calculate-size-test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData)
      })
      .then(response => response.json())
      .then(data => {
        if (postData.gender === 'femaleall') {
          updateUIWithResultsFemaleAll(data, postData);
        } else {
          updateUIWithResults(data, postData);
        }

      })
      .catch(error => {
        console.error('Error:', error);
        $('#size-finder-loader').hide();
        $('#size-assist-form').fadeIn();
      });

        
      fetch('https://theshopcompany.vercel.app/api/save-to-sheets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData)
      })
      .then(response => response.json())
      .catch(error => {
        console.error('Error:', error);
      })
      

    }, 300);
  });
  // Restore locked state on page load
  if (sessionStorage.getItem('sizeFinderLocked') === '1') {
      menuItem.addClass('locked-open');
  }
$(document).on('click', function (e) {
    if (!$(e.target).closest('.size-finder-menu-item').length) {
        $('.size-finder-menu-item').removeClass('locked-open');
        sessionStorage.removeItem('sizeFinderLocked');
    }
});  

function updateUIWithResultsFemaleAll(data, postData) {
  $('.clear-all').remove();
  var html = '';

  $('#sizeAssistresponce').addClass('all-result-container');
  $('#sizeAssistresponce').before(
  '<div class="size-match-clear clear-all">Clear Result</div>'
);

  if (!data.results_by_type) {
    $('#sizeAssistresponce').html('<div>No results found</div>');
    return;
  }
  var explain_html = '';
  //html += '<div class="size-match-clear clear-all">Clear Result</div>';
  Object.keys(data.results_by_type).forEach(function (category) {
    const categoryResults = data.results_by_type[category];
    const picked = pickTopTwoByScore(categoryResults);
    if (!picked || !picked.recommended) return;

    const rec = picked.recommended;
    const other = picked.other_size;
    console.log(category);
    if(category == 'standard'){
      explain_html = rec.padding_kids_headings_max;
      explain_html += rec.padding_kids_headings_with_height
    }
    console.log(rec.padding_kids_headings_max);


    html += '<div class="femaleall-category '+category+'">';
    // Reuse existing table logic
    html += renderSingleResultTable(category,rec, other, postData);
    html += '</div>';
  });

      /*html +='<p class="soft-form-notice female-all"><strong>Important:</strong> this Size Finder currently only checks against our original Professional Dress Form models. As of December 2025, we have introduced a new "Soft Foam" model which uses a different measurements system (ASTM Straight). See the new Soft Foam model <a href="/products/professional-female-3-4-body-dress-form-soft-foam-fully-pinnable" style="text-decoration:underline">here</a>.</p>';*/
      html += '</div><div class="size-match-explanation female-all"><div class="size-match-explanation-inner">';
      html += explain_html;
      html += '</div></div>';

  $('#sizeAssistresponce').html(html);
  $('#size-finder-loader').hide();
    $('#size-assist-form').hide();

   var date = new Date();
    date.setTime(date.getTime() + (365*24*60*60*1000));
    var expires = '; expires=' + date.toGMTString();
    document.cookie = 'best_match_result_html=' + encodeURIComponent(html) + expires + '; path=/';
    document.cookie = 'best_match_result_data=' + encodeURIComponent(JSON.stringify(postData)) + expires + '; path=/';

  
}
function pickTopTwoByScore(items) {
  if (!items || !items.length) return null;

  const sorted = [...items].sort((a, b) => b._score - a._score);

  return {
    recommended: sorted[1],
    other_size: sorted[0] || null
  };
}


function renderSingleResultTable(category,recommended, other_size, postData) {
  var html = '';
  var other_size_exists = '';
  var otherExists = other_size && other_size.size !== recommended.size;
  if(otherExists){
    other_size_exists = '<span class="size-match-switch" id="'+category+'-alternate-match-show">alternate</span>';
  }

  if(category=="soft"){category="soft foam";}


      html += '<div class="long-table-cont '+category+'"><div class="'+category+'-main-size-result"><div class="cat-label">'+category+'</div><table class="table"><thead><tr><td colspan="4"><h1>Best Match: Size ' + recommended.size + '</h1><div class="size-suggestion-options">' + other_size_exists + '</div></td></tr></thead>';
      html += '<tbody><tr>';
      html += '<td></td>';
      html += '<td style="white-space: nowrap">Size ' + recommended.size + '</td>';
      html += '<td>You</td>';
      html += '<td>Our Thoughts</td></tr>';
      html += '<tr><td>Bust</td>';
      html += '<td>' + recommended.chest_bust.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.chest_bust* 100) / 100 + '</td>';
      html += '<td>' + recommended.chest_bust.match_advice + '</td></tr>';
      html += '<tr><td>Waist</td>';
      html += '<td>' + recommended.waist.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.waist* 100) / 100 + '</td>';
      html += '<td>' + recommended.waist.match_advice + '</td></tr>';
      html += '<tr><td>Hips</td>';
      html += '<td>' + recommended.hips.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.hips* 100) / 100 + '</td>';
      html += '<td>' + recommended.hips.match_advice + '</td></tr>';
      html += '</tbody></table></div>';

      if (other_size.size != recommended.size) {
        html += '<div class="'+category+'-other-size-result" style="display:none;"><div class="cat-label">'+category+'</div><table class="table"><thead><tr><td colspan="4"><h1> Other Match: Size ' + other_size.size + '</h1><div class="size-suggestion-options"><span class="size-match-switch" id="'+category+'-best-match-show">best</span></div></td></tr></thead>';
        html += '<tbody><tr>';
        html += '<td></td>';
        html += '<td style="white-space: nowrap">Size ' + other_size.size + '</td>';
        html += '<td>You</td>';
        html += '<td>Our Thoughts</td></tr>';
        html += '<tr><td>Bust</td>';
        html += '<td>' + other_size.chest_bust.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.chest_bust* 100) / 100 + '</td>';
        html += '<td>' + other_size.chest_bust.match_advice + '</td></tr>';
        html += '<tr><td>Waist</td>';
        html += '<td>' + other_size.waist.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.waist* 100) / 100 + '</td>';
        html += '<td>' + other_size.waist.match_advice + '</td></tr>';
        html += '<tr><td>Hips</td>';
        html += '<td>' + other_size.hips.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.hips* 100) / 100 + '</td>';
        html += '<td>' + other_size.hips.match_advice + '</td></tr>';
        html += '</tbody></table></div>';
      }



  html += '</div>';
  return html;
}







  function updateUIWithResults(data, postData) {
      $('#sizeAssistresponce').removeClass('all-result-container');
      $('.clear-all').remove();
      

    var html = '';
    var other_size_exists = '';
    if (data.erroromsg) {
      html += '<div>' + data.erroromsg + ' <span class="size-match-clear">clear results</span></div>';
    } else {
      if (data.other_size.size != data.recommended.size) {
        other_size_exists = '<span class="size-match-switch" id="alternate-match-show">alternate</span>/';
      }

      html += '<div class="long-table-cont"><div class="main-size-result"><table class="table"><thead><tr><td colspan="4"><h1>Best Match: Size ' + data.recommended.size + '</h1><div class="size-suggestion-options">' + other_size_exists + '<span class="size-match-clear">clear results</span></div></td></tr></thead>';
      html += '<tbody><tr>';
      html += '<td></td>';
      html += '<td style="white-space: nowrap">Size ' + data.recommended.size + '</td>';
      html += '<td>You</td>';
      html += '<td>Our Thoughts</td></tr>';
      html += '<tr><td>Bust</td>';
      html += '<td>' + data.recommended.chest_bust.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.chest_bust * 100) / 100 + '</td>';
      html += '<td>' + data.recommended.chest_bust.match_advice + '</td></tr>';
      html += '<tr><td>Waist</td>';
      html += '<td>' + data.recommended.waist.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.waist* 100) / 100 + '</td>';
      html += '<td>' + data.recommended.waist.match_advice + '</td></tr>';
      html += '<tr><td>Hips</td>';
      html += '<td>' + data.recommended.hips.attribute_value + '</td>';
      html += '<td>' + Math.round(postData.hips* 100) / 100 + '</td>';
      html += '<td>' + data.recommended.hips.match_advice + '</td></tr>';
      html += '</tbody></table></div>';

      var emailText = 'The measurements entered were ';
      emailText += Math.round(postData.chest_bust* 100) / 100;
      emailText += ', ';
      emailText += Math.round(postData.waist* 100) / 100;
      emailText += ' and ';
      emailText += Math.round(postData.hips* 100) / 100;
      emailText += ' and the best match was shown as a size ';
      emailText += data.recommended.size;
      emailText += ' (' + data.recommended.chest_bust.attribute_value + ', ' + data.recommended.waist.attribute_value + ', ' + data.recommended.hips.attribute_value + '). ';
      var emailBody = emailText;

      if (data.other_size.size != data.recommended.size) {
        html += '<div class="other-size-result"><table class="table"><thead><tr><td colspan="4"><h1>Other Match: Size ' + data.other_size.size + '</h1><div class="size-suggestion-options"><span class="size-match-switch" id="best-match-show">best</span>/<span class="size-match-clear">clear results </span></div></td></tr></thead>';
        html += '<tbody><tr>';
        html += '<td></td>';
        html += '<td style="white-space: nowrap">Size ' + data.other_size.size + '</td>';
        html += '<td>You</td>';
        html += '<td>Our Thoughts</td></tr>';
        html += '<tr><td>Bust</td>';
        html += '<td>' + data.other_size.chest_bust.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.chest_bust * 100) / 100 + '</td>';
        html += '<td>' + data.other_size.chest_bust.match_advice + '</td></tr>';
        html += '<tr><td>Waist</td>';
        html += '<td>' + data.other_size.waist.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.waist* 100) / 100 + '</td>';
        html += '<td>' + data.other_size.waist.match_advice + '</td></tr>';
        html += '<tr><td>Hips</td>';
        html += '<td>' + data.other_size.hips.attribute_value + '</td>';
        html += '<td>' + Math.round(postData.hips* 100) / 100 + '</td>';
        html += '<td>' + data.other_size.hips.match_advice + '</td></tr>';
        html += '</tbody></table></div>';
      }
      /* html +='<p class="soft-form-notice"><strong>Important:</strong> this Size Finder currently only checks against our original Professional Dress Form models. As of December 2025, we have introduced a new "Soft Foam" model which uses a different measurements system (ASTM Straight). See the new Soft Foam model <a href="/products/professional-female-3-4-body-dress-form-soft-foam-fully-pinnable" style="text-decoration:underline">here</a>.</p>'; */
      html += '</div><div class="size-match-explanation"><div class="size-match-explanation-inner">';
      html += data.recommended.padding_kids_headings_max || '';
      html += data.recommended.padding_kids_headings_with_height || '';
      html += '<p class="size-finder-email">Questions? Please <a href="mailto:sales@theshopcompany.com?subject=TSC Size Finder Results&body=' + encodeURIComponent(emailBody) + '" style="text-decoration:underline">email us</a></p>';
      html += '</div></div>';
    }
    $('#sizeAssistresponce').html(html);
    $('#size-finder-loader').hide();
    $('#size-assist-form').hide();
    var date = new Date();
    date.setTime(date.getTime() + (365*24*60*60*1000));
    var expires = '; expires=' + date.toGMTString();
    document.cookie = 'best_match_result_html=' + encodeURIComponent(html) + expires + '; path=/';
    document.cookie = 'best_match_result_data=' + encodeURIComponent(JSON.stringify(postData)) + expires + '; path=/';
  }

  var nameEQ = encodeURIComponent('best_match_result_html') + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ')
      c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      $('#sizeAssistresponce').html(decodeURIComponent(c.substring(nameEQ.length, c.length)));
    }
  }

  $(document).ready(function() {
    $('#bust, #waist, #hips').attr('type', 'number').attr('min', '1').attr('pattern', '\\d+').prop('required', true);
    
    (function() {
      var lastIsMobile = window.innerWidth <= 767;
      window.addEventListener('resize', function() {
        var isMobile = window.innerWidth <= 767;
        if (isMobile !== lastIsMobile) {
          window.location.reload();
          lastIsMobile = isMobile;
        }
      });
    })();

    if (!$('#sizeAssistresponce').is(':empty')) {
      $('#size-assist-form').hide();
    }
    if ($(window).width() <= 768) {
      $('#header-link-size-subheader').empty();
    } else {
      $('#mobile-nav-item-2-sub').empty();
    }
  });
/*
  $(document).on('click', '.size-field', function(e) {
    e.preventDefault();
    $(this).find('.radio').prop('checked', true);
    if ($(this).hasClass('choice-chosen')) {
      return false;
    } else {
      $(this).siblings().removeClass('choice-chosen');
      $(this).addClass('choice-chosen');
    }
  });
*/
  $(document).on('click', '.size-field', function (e) {
  e.preventDefault();
  const $radio = $(this).find('input[type="radio"]');
  const name   = $radio.attr('name');
  // Check the radio
  $radio.prop('checked', true);
  // Remove chosen class from ALL fields with same radio name
  $('input[type="radio"][name="' + name + '"]')
    .closest('.size-field')
    .removeClass('choice-chosen');

  // Add chosen class to current
  $(this).addClass('choice-chosen');
});


  $(document).on('click', '.size-match-switch', function(e) {
    e.preventDefault();
    if ($(this).is('#alternate-match-show') ) {
      $('.main-size-result').hide();
      $('.other-size-result').fadeIn({ queue: false });
    } 
    if($(this).is('#best-match-show')) {
      $('.other-size-result').hide();
      $('.main-size-result').fadeIn({ queue: false });
    }
    // standard
    if($(this).is('#standard-best-match-show')) {
      $('.standard-other-size-result').hide();
      $('.standard-main-size-result').fadeIn({ queue: false });
    }
    if ($(this).is('#standard-alternate-match-show') ) {
      $('.standard-main-size-result').hide();
      $('.standard-other-size-result').fadeIn({ queue: false });
    } 
    //soft
    if($(this).is('#soft-best-match-show')) {
      $('.soft-other-size-result').hide();
      $('.soft-main-size-result').fadeIn({ queue: false });
    }
    if ($(this).is('#soft-alternate-match-show') ) {
      $('.soft-main-size-result').hide();
      $('.soft-other-size-result').fadeIn({ queue: false });
    } 
    //petite
    if($(this).is('#petite-best-match-show')) {
      $('.petite-other-size-result').hide();
      $('.petite-main-size-result').fadeIn({ queue: false });
    }
    if ($(this).is('#petite-alternate-match-show') ) {
      $('.petite-main-size-result').hide();
      $('.petite-other-size-result').fadeIn({ queue: false });
    } 
    
    return false;
  });



  
  $(document).on('click', '.size-match-clear', function(e) {
    e.preventDefault();
    document.cookie = 'best_match_result_html=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'best_match_result_data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    $('#sizeAssistresponce').empty();
    $('#size-assist-form').show();
    return false;
  });

  $(document).on('click', '.read-more', function(e) {
    e.preventDefault();
    $('.size-match-explanation-inner p').show();
    $('.read-more').hide();
    return false;
  });

})(jQuery);

$("li#header-link-size").on("click", function() {
  $("div#header-link-size-subheader").slideToggle();
  $(this).toggleClass("clicked");
});
/*
$(document).on('mousedown touchstart', function(event) {
  var $subheader = $("div#header-link-size-subheader");
  var $trigger = $("li#header-link-size");
  if ($subheader.is(":visible") &&
      !$subheader.is(event.target) && $subheader.has(event.target).length === 0 &&
      !$trigger.is(event.target) && $trigger.has(event.target).length === 0) {
    $subheader.slideUp();
    $trigger.removeClass("clicked");
  }
}); */